import React, { useMemo } from 'react';


import twentyfourhouraccess from 'assets/images/features-amenities/24-hr-access.svg';
import car from 'assets/images/features-amenities/car.svg';
import climatecontrolled from 'assets/images/features-amenities/climate-controlled.svg';
import driveupaccess from 'assets/images/features-amenities/drive-up-access.svg';
import fencedlit from 'assets/images/features-amenities/fenced-lit.svg';
import firstflooraccess from 'assets/images/features-amenities/first-floor-access.svg';

const amenityIconMap = {
    'twenty four hour access': twentyfourhouraccess,
    'drive up access': driveupaccess,
    'climate controlled': climatecontrolled,
    'vehicle accommodation': car,
    'light in unit': fencedlit,
    'floor 1': firstflooraccess,
};
const useFilteredAmenities = (amenitiesList) => {
    const filteredAmenities = useMemo(() => {
        if (typeof amenitiesList === 'string') {
            amenitiesList = amenitiesList.split(',').map((item) => item.trim());
        }

        if (!Array.isArray(amenitiesList))
			return { withIcons: [], withoutIcons: [] };

        // Helper function to capitalize the first letter
        const capitalizeFirstLetter = (string) =>
            string.charAt(0).toUpperCase() + string.slice(1);

        // Separate amenities with and without icons
        const withIcons = [];
        const withoutIcons = [];
        const AllAmenities = [];

        amenitiesList.forEach((amenity) => {
            const capitalizedAmenity = capitalizeFirstLetter(amenity);
            const iconKey = Object.keys(amenityIconMap).find(
                (key) => key.toLowerCase() === amenity.toLowerCase()
            );

            AllAmenities.push({
                name: capitalizedAmenity,
                key: amenity,
            });

            if (iconKey) {
                withIcons.push({
                    name: capitalizedAmenity,
                    icon: amenityIconMap[iconKey],
                    key: amenity,
                    hasIcon: true,
                });
            } else {
                withoutIcons.push({
                    name: capitalizedAmenity,
                    icon: null,
                    key: amenity,
                    hasIcon: false,
                });
            }
        });

        return { withIcons, withoutIcons, AllAmenities};
    }, [amenitiesList]);

    return filteredAmenities;
};

const AmenitiesList = ({ amenitiesList }) => {
    const { withIcons, withoutIcons, AllAmenities } = useFilteredAmenities(amenitiesList);

    return { withIcons, withoutIcons, AllAmenities };
};
export default AmenitiesList;
